import { Box, Flex, Image } from '@everlywell/ui-kit';
import Carousel, { CarouselProps } from 'components/Carousel';
import { GatsbyImage as Img } from 'gatsby-plugin-image';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

// Types ----------

export type ImageElement = {
  image: IGatsbyImageData;
  alt: string;
};

export interface ImageCarouselProps {
  images: ImageElement[];
  slideStyle?: CarouselProps['slideStyle'];
}

// ImageCarousel ------

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  images,
  slideStyle = {},
}) => (
  <Box backgroundColor="tints.lightCream" borderRadius={'xl'} overflow="hidden">
    <Carousel
      arrowInsideOffset
      insidePagination={true}
      pagination={{ clickable: true, enabled: images.length > 1 }}
      showPagination
      slideStyle={slideStyle}
      slidesPerView={1}
      spaceBetween={0}
    >
      {images.map((image, index) => (
        <Flex key={index} justifyContent="center">
          <Box>
            <Image
              alt={image.alt}
              as={Img}
              aspectRatio={'1.5'}
              image={image.image}
              objectFit="fill"
            />
          </Box>
        </Flex>
      ))}
    </Carousel>
  </Box>
);

// Export ---------

export default React.memo(ImageCarousel);
